export const REQUEST_TASKS = "REQUEST_TASKS";
export const CLEAR_TASKS = "CLEAR_TASKS";
export const REQUEST_TASKS_FOR_TECH = "REQUEST_TASKS_FOR_TECH";
export const REQUEST_TASKS_SUCCEEDED = "REQUEST_TASKS_SUCCEEDED";
export const REQUEST_TASKS_COMPLETED = "REQUEST_TASKS_COMPLETED";
export const REQUEST_TASKS_FAILED = "REQUEST_TASKS_FAILED";

// Reload a task
export const REQUEST_TASK_RELOAD = "REQUEST_TASK_RELOAD";
export const TASK_RELOAD_SUCCEEDED = "TASK_RELOAD_SUCCEEDED";
export const TASK_RELOAD_FAILED = "TASK_RELOAD_FAILED";

// Task actions
export const TASK_UNASSIGN = "TASK_UNASSIGN";
export const TASK_ENROUTE = "TASK_ENROUTE";
export const TASK_ONSITE = "TASK_ONSITE";
export const TASK_COMPLETE = "TASK_COMPLETE";
export const TASK_INCOMPLETE = "TASK_INCOMPLETE";
export const TASK_INCOMPLETED = "TASK_INCOMPLETED";
export const TASK_FOLLOWUP = "TASK_FOLLOWUP";

// fetch workorder info
export const REQUEST_WORKORDER = "REQUEST_WORKORDER";
export const REQUEST_WORKORDER_SUCCESS = "REQUEST_WORKORDER_SUCCESS";
export const UPDATE_WORKORDER_STATUS = "UPDATE_WORKORDER_STATUS";

// fetch workorder purchase number
export const REQUEST_WORKORDER_PURCHASE_NUM = "REQUEST_WORKORDER_PURCHASE_NUM";
export const REQUEST_WORKORDER_PURCHASE_NUM_SUCCESS = "REQUEST_WORKORDER_PURCHASE_NUM_SUCCESS";
//fetch vendor manager
export const REQUEST_WORKORDER_VENDOR_MANAGER = "REQUEST_WORKORDER_VENDOR_MANAGER";
export const REQUEST_WORKORDER_VENDOR_MANAGER_SUCCESS = "REQUEST_WORKORDER_VENDOR_MANAGER_SUCCESS";
// sent to bell
export const REQUEST_SENT_TO_BELL = "REQUEST_SENT_TO_BELL";

// PATCH task
export const REQUEST_TASK_PATCH = "REQUEST_TASK_PATCH";

export const REQUEST_REASON_CODES = "REQUEST_REASON_CODES";
export const REQUEST_REASON_CODES_SUCCESS = "REQUEST_REASON_CODES_SUCCESS";
export const INCOMPLETE_TASK_WITH_REASON = "INCOMPLETE_TASK_WITH_REASON";
export const REQUEST_TO_TAB_CHANGE = "REQUEST_TO_TAB_CHANGE";
export const INCOMPLETE_TASK_RESPONSE = "INCOMPLETE_TASK_RESPONSE";

export const SAVE_PERMIT_INFO = "SAVE_PERMIT_INFO";

export const SAVE_PERMIT_INFO_SUCCEEDED = "SAVE_PERMIT_INFO_SUCCEEDED";

export const GET_TASK_RELATEDWO = "GET_TASK_RELATEDWO";
export const GET_TASK_RELATEDWO_SUCCESS = "GET_TASK_RELATEDWO_SUCCESS";

export const GET_TASK_ASSIGNMENT = "GET_TASK_ASSIGNMENT";
export const GET_TASK_ASSIGNMENT_SUCCESS = "GET_TASK_ASSIGNMENT_SUCCESS";

export const GET_WORKORDER_CANCELLED_REASON = "GET_WORKORDER_CANCELLED_REASON";
export const GET_WORKORDER_CANCELLED_REASON_SUCCESS = "GET_WORKORDER_CANCELLED_REASON_SUCCESS";

export const GET_MULTIPLE_WORKACTIVITY = "GET_MULTIPLE_WORKACTIVITY";
export const GET_MULTIPLE_WORKACTIVITY_SUCCESS = "GET_MULTIPLE_WORKACTIVITY_SUCCESS";
export const REQUEST_ALL_STATUS_FAILED = "REQUEST_ALL_STATUS_FAILED";
export const REQUEST_ALL_STATUS_SUCCEEDED = "REQUEST_ALL_STATUS_SUCCEEDED";
export const REQUEST_ALL_STATUS = "REQUEST_ALL_STATUS";
export const CLEAR_WORKORDER_DATA = "CLEAR_WORKORDER_DATA";
export const CLEAR_ASSIGNMENTS_INFO = "CLEAR_ASSIGNMENTS_INFO";
export const CLEAR_TASK_COUNTS = "CLEAR_TASK_COUNTS";
export const REQUEST_TO_ADD_FOLLOWUP = "REQUEST_TO_ADD_FOLLOWUP";
export const SHOW_FOLLOWUPS = "SHOW_FOLLOWUPS";
export const COMPLETION_PAYLOAD = "COMPLETION_PAYLOAD";
export const BUTTON_DISABLED = "BUTTON_DISABLED";
export const BILLLING_REASON_MANDATORY = "BILLLING_REASON_MANDATORY";
export const DISABLE_BELL_TO_SEND_BUTTON = "DISABLE_BELL_TO_SEND_BUTTON";

export const requestTasks = (fetchCounts) => {
    return {
        type: REQUEST_TASKS,
        fetchCounts: true,
        workOrderNumber: fetchCounts?.workOrderNumber,
    };
};

export const clearTasks = () => {
    return {
        type: CLEAR_TASKS,
    };
};

export const clearTaskCounts = () => {
    return {
        type: CLEAR_TASK_COUNTS,
    };
};

export const requestTasksForTechnician = () => {
    return {
        type: REQUEST_TASKS_FOR_TECH,
    };
};

export const requestTasksSucceeded = (results, lang) => {
    //  const intl = useIntl()
    let result = results;
    var idx = 0;
    //var lang = cookies.get('locale');
    const taskValue = results.tasks.map((task) => {
        task.id = task.workOrderNumber;
        // task['activity_display'] = lang === "en" ? task.workActivityName_en : task.workActivityName_fr;
        // task['statusName_display'] = lang === "en" ? task.statusName_en : task.statusName_fr;
        // task['additionalAction_display'] = lang === "en" ? task.additionalAction_EN : task.additionalAction_FR;
        // task['reasonCode_display'] = lang === "en" ? task.reasonCodeName_en : task.reasonCodeName_fr;
        // task['priority_display'] = lang === "en" ? task.priorityName_en : task.priorityName_fr;
        // task['networkType_display'] = lang === "en" ? task.networkType_EN : task.networkType_FR;
        // task['PermitStatus_display'] = lang === "en" ? task.permitStatusEn : task.permitStatusFr;
        // task['FollowUpType_display'] = lang === "en" ? task.followUpType_EN : task.followUpType_Fr;
        // //task['workType_display'] = lang === "en" ? task.worktypeName_en : task.worktypeName_fr;
        // task['plantType_display'] = lang === "en" ? task.plantTypeEn : task.plantTypeFr;
        // task['parentType_display'] = lang === "en" ? task.parentType_EN : task.parentType_FR;
        return task;
    });
    result.tasks = taskValue;
    // results.tasks.sort((a, b) => (a.sourceOrderId > b.sourceOrderId) ? 1 : ((b.sourceOrderId < a.sourceOrderId) ? -1 : 0));
    return {
        type: REQUEST_TASKS_SUCCEEDED,
        tasks: results,
    };
};

export const requestTasksFailed = (message) => {
    return {
        type: REQUEST_TASKS_FAILED,
        message,
    };
};

export const fetchWorkorder = (workorderNumber, withSKUs, isTechnician, history) => {
    return {
        type: REQUEST_WORKORDER,
        workorderNumber,
        withSKUs,
    };
};

export const fetchWorkorderSuccess = (workorderData) => {
    return {
        type: REQUEST_WORKORDER_SUCCESS,
        workorderData,
    };
};

export const clearWorkOrderData = () => {
    return {
        type: CLEAR_WORKORDER_DATA,
    };
};

export const updateWorkOrderStatus = (status) => {
    return {
        type: UPDATE_WORKORDER_STATUS,
        status,
    };
};

export const fetchWorkorderPONum = (workorderNumber) => {
    return {
        type: REQUEST_WORKORDER_PURCHASE_NUM,
        workorderNumber,
    };
};

export const fetchWorkorderPONumSuccess = (billingsInfo) => {
    return {
        type: REQUEST_WORKORDER_PURCHASE_NUM_SUCCESS,
        purchaseOrderNumber: billingsInfo && billingsInfo.purchaseOrderNumber ? billingsInfo.purchaseOrderNumber : "",
    };
};

export const fetchVendorManager = (clliCode, workActivityId) => {
    return {
        type: REQUEST_WORKORDER_VENDOR_MANAGER,
        clliCode,
        workActivityId,
    };
};

export const fetchVendorManagerSuccess = (vendorManager) => {
    return {
        type: REQUEST_WORKORDER_VENDOR_MANAGER_SUCCESS,
        vendorManagerByOrder: vendorManager,
    };
};

export const requestTaskReload = (workorderNumber, isUnassigned) => {
    return {
        type: REQUEST_TASK_RELOAD,
        workorderNumber,
        isUnassigned,
    };
};

export const taskReloadSucceeded = (task) => {
    return {
        type: TASK_RELOAD_SUCCEEDED,
        task,
    };
};

export const taskUnassign = (workOrderNumber) => {
    return {
        type: TASK_UNASSIGN,
        workOrderNumber,
    };
};

export const taskEnroute = (workOrderNumber, shouldRefresh = true) => {
    return {
        type: TASK_ENROUTE,
        workOrderNumber,
        shouldRefresh,
    };
};

export const taskOnsite = (workOrderNumber, shouldRefresh = true) => {
    return {
        type: TASK_ONSITE,
        workOrderNumber,
        shouldRefresh,
    };
};

export const taskComplete = (workOrderNumber, taskUpdate, history) => {
    return {
        type: TASK_COMPLETE,
        workOrderNumber,
        taskUpdate,
    };
};

export const taskIncomplete = (workOrderNumber, taskUpdate) => {
    return {
        type: TASK_INCOMPLETE,
        workOrderNumber,
        taskUpdate,
    };
};

export const taskIncompleted = (workOrderNumber) => {
    return {
        type: TASK_INCOMPLETED,
        workOrderNumber,
    };
};

export const taskFollowUp = (workOrderNumber, taskUpdate) => {
    return {
        type: TASK_FOLLOWUP,
        workOrderNumber,
        taskUpdate,
    };
};

export const taskSendToBell = (workOrderNumber, withSKUs) => {
    return {
        type: REQUEST_SENT_TO_BELL,
        withSKUs,
        workOrderNumber,
    };
};

export const taskPatch = (taskId, workOrderNumber, patchDetails, withSKUs) => {
    return {
        type: REQUEST_TASK_PATCH,
        taskId,
        workOrderNumber,
        patchDetails,
        withSKUs,
    };
};

export const incompleteTaskWithReason = (jobData, followUpInfo) => ({ type: INCOMPLETE_TASK_WITH_REASON, jobData, followUpInfo });

export const requestToTabChange = (data) => ({ type: REQUEST_TO_TAB_CHANGE, data });

export const requestToAddFollowup = (data) => ({ type: REQUEST_TO_ADD_FOLLOWUP, data });
export const showFollowUps = (data) => ({ type: SHOW_FOLLOWUPS, data });
export const buttonDisabled = (data) => ({ type: BUTTON_DISABLED, data });
export const billingReasonMandatory = (payload) => ({ type: BILLLING_REASON_MANDATORY, payload });

export const completionPayload = (data) => ({ type: COMPLETION_PAYLOAD, data });

export const incompleteTaskResponse = (patch) => {
    return {
        type: INCOMPLETE_TASK_RESPONSE,
        incompleteTaskResponse: patch,
    };
};
export const savePermitInfo = (permitInfo, workOrderNumber, refresh) => {
    return {
        type: SAVE_PERMIT_INFO,

        permitInfo,
        workOrderNumber,
        refresh,
    };
};

export const savePermitInfoSucceeded = (permitInfoResponse) => {
    return {
        type: SAVE_PERMIT_INFO_SUCCEEDED,
        permitInfoResponse,
    };
};

export const getAssignmentInformation = (phoneNumber) => {
    return {
        type: GET_TASK_ASSIGNMENT,
        phoneNumber,
    };
};

export const getAssignmentInformationSuccess = (getAssignmentInformationResponse) => {
    return {
        type: GET_TASK_ASSIGNMENT_SUCCESS,
        assignmentInformation: getAssignmentInformationResponse,
    };
};

export const getRelatedWO = (relatedId) => {
    return {
        type: GET_TASK_RELATEDWO,
        relatedId,
    };
};

export const getRelatedWOSuccess = (getRelatedWOResponse) => {
    return {
        type: GET_TASK_RELATEDWO_SUCCESS,
        relatedIdInformation: getRelatedWOResponse,
    };
};

export const requestAllStatus = () => {
    return {
        type: REQUEST_ALL_STATUS,
    };
};

export const requestAllStatusSucceeded = (allStatus) => {
    return {
        type: REQUEST_ALL_STATUS_SUCCEEDED,
        allStatus,
    };
};
export const requestAllStatusFailed = (allStatus) => {
    return {
        type: REQUEST_ALL_STATUS_FAILED,
    };
};
export const clearAssignmentsInfo = () => {
    return {
        type: CLEAR_ASSIGNMENTS_INFO,
    };
};

export const getCancelWorkorderReason = (workOrderNumber, contractorNumber) => {
    return {
        type: GET_WORKORDER_CANCELLED_REASON,
        workOrderNumber,
        contractorNumber,
    };
};

export const getCancelWorkorderReasonSuccess = (cancelledWorkOrderReasonResponse) => {
    return {
        type: GET_WORKORDER_CANCELLED_REASON_SUCCESS,
        cancelledWorkOrderReasons: cancelledWorkOrderReasonResponse,
    };
};

export const disableBellToSendButton = (payload) => {
    return {
        type: DISABLE_BELL_TO_SEND_BUTTON,
        payload,
    };
};
